import * as actionTypes from "./actionTypes";

export const addNewPhysicalInventoryAction = (physicalInventoryData) => {
  return { type: actionTypes.ADD_NEW_PHYSICAL_INVENTORY, physicalInventoryData };
};

export const addNewPhysicalInventorySuccessAction = (captureGoodsResponse) => {
  return { type: actionTypes.ADD_NEW_PHYSICAL_INVENTORY_SUCCESS, captureGoodsResponse };
};

export const editPhysicalInventoryAction = (physicalInventoryData) => {
  return { type: actionTypes.EDIT_PHYSICAL_INVENTORY, physicalInventoryData };
};

export const editPhysicalInventorySuccessAction = (captureGoodsResponse) => {
  return { type: actionTypes.EDIT_PHYSICAL_INVENTORY_SUCCESS, captureGoodsResponse };
};

export const deletePhysicalInventoryAction = (physicalInventoryData) => {
  return { type: actionTypes.DELETE_PHYSICAL_INVENTORY, physicalInventoryData };
};

export const deletePhysicalInventorySuccessAction = (captureGoodsResponse) => {
  return { type: actionTypes.DELETE_PHYSICAL_INVENTORY_SUCCESS, captureGoodsResponse };
};
